import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CoreModule } from '../../../core/core.module';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'brt-order-summary',
  standalone: true,
  imports: [
    CommonModule, CoreModule, 
    MatCardModule,
  ],
  templateUrl: './order-summary.component.html',
  styleUrl: './order-summary.component.css'
})
export class OrderSummaryComponent {
  @Input() order: any;
  @Input() selected: boolean;  
  orderStatus: string;

  ngOnInit(): void {
    switch (this.order.Status) {
      case 'Accepted':
        this.orderStatus = 'success';
        break;
      case 'Delivered':
        this.orderStatus = 'info';
        break;
      case 'Rejected':
        this.orderStatus = 'danger';
        break;
      case 'Pending':
        this.orderStatus = 'warning';
        break;
      default:
        this.orderStatus = 'default';
        break;
    }
  }
}
